import type React from 'react';
import { useEffect, useRef } from 'react';

export default function useFocusRef<T extends HTMLElement>(dependencies: any[] = [], disableAutoFocus = false): React.RefObject<T> {
  const ref = useRef<T>(null);
  useEffect(() => {
    if (disableAutoFocus) return;
    ref.current?.focus();
  }, [...dependencies, ref, ref.current]);

  return ref;
}
